var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShowAddressInfo)?_c('el-cascader',{key:_vm.myKey,attrs:{"size":_vm.size,"clearable":_vm.clearable,"placeholder":_vm.$t(_vm.placeholder),"disabled":_vm.disabled,"props":_vm.props},on:{"change":_vm.handleChange},model:{value:(_vm.value2),callback:function ($$v) {_vm.value2=$$v},expression:"value2"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }